<template>
    <div id="login">
        <canvas id="canvas" style="background:#e4e4e4"></canvas>
        <div class="loginStyle">
            <div class="loginRight">
                <p style="padding:22px 0px 6px;font-size:28px;font-weight:400;color:#444;text-align:center;">卡管理平台</p>
                <el-form :model="loginForms" ref="loginForms" :rules="rules" style="width:85%; margin:12px auto 0;" class="iptStyle" size="small">
                    <el-form-item prop="userName" :rules="filter_rules({required:true,type:'userName',message:'请输入用户名称',min:5,max:45})">
                        <el-input v-model="loginForms.userName" placeholder="请输入用户名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="passWord" :rules="filter_rules({required:true,type:'passwords',message:'请输入密码',min:6,max:16})">
                        <el-input type='password' v-model="loginForms.passWord" placeholder="请输入密码" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="imgCode" style="position:relative;">
                        <el-input v-model="loginForms.imgCode" placeholder="请输入验证码" :maxlength='4' clearable style="width:200px;"></el-input>
                        <span style="display:block;position:absolute;right:78px;top:0px;width:97px;height:32px;border:1px solid #ccc;border-radius:4px;padding:2px 0px 0px 2px;"><img :src='codeSrc' @click="getCode()" alt=""></span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click.native.prevent="codeLogin('loginForms')" @keyup.enter.native="codeLogin('loginForms')" style="font-size:14px;width:100%;">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    var axios = require('axios')
    import {mapActions} from "vuex";

    export default {
        name: 'login',
        data() {
            return {
                codeSrc: "",
                rules: {
                    imgCode: [
                        {required: true, message: '请输入验证码', trigger: ["blur", "change"]},
                        {pattern: /^[a-zA-Z0-9]+$/, message: "由大小写字母，数字组成"},
                        {min: 4, message: "长度为4个字符", trigger: ["blur", "change"]}
                    ]
                },
                loginForms: {
                    userName: '',
                    passWord: '',
                    imgCode: ''
                },
                Timer: null,
            };
        },
        methods: {
            ...mapActions([
                'saveInfo', 'saveLogUrl'
            ]),
            //登录
            codeLogin(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.IsCode();
                    } else {
                        return false;
                    }
                });
            },
            //获取验证码
            getCode() {
                this.codeSrc = this.API.url + "imgCode?d=" + Math.random();
            },
            //判断验证码是否正确
            IsCode() {
                axios.defaults.withCredentials = true;
                axios({
                    method: 'post',
                    url: this.API.url + 'checkImgCode',
                    data: {'imgCode': this.loginForms.imgCode},
                    transformRequest: [function (data) {
                        let ret = ''
                        for (let it in data) {
                            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
                        }
                        return ret
                    }],
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                })
                    .then(resd => {
                        if (resd.data.code == 200) {
                            this.loginSend();
                        } else {
                            this.getCode(); //重新获取验证码
                            this.loginForms.imgCode = ''; //验证码制空
                            return false;
                        }
                    })
            },
            //发送登录请求
            loginSend() {
                let obj = {};
                Object.assign(obj, this.loginForms);
                obj.passWord = this.$md5(obj.passWord);
                axios.defaults.withCredentials = true;
                axios({
                    method: 'post',
                    url: this.API.url + 'login',
                    data: obj,
                })
                    .then(resd => {
                        if (resd.data.code == 200) {
                            document.cookie = "tibiot-personal-card=Bearer " + resd.data.data.val + ";path=/;"
                            this.$router.push('/home'); //跳转页面
                            this.saveLogUrl({logUrl: '/home'});
                        } else {
                            this.$message.error(resd.data.message);
                        }
                    })
            },
            // -------- 设置背景canvas ---------
            setDATA() {
                let cv = document.querySelector("#canvas");
                let width = 0;
                let height = 0;
                width = (cv.width = document.querySelector("#login").offsetWidth);
                height = (cv.height = document.querySelector("#login").offsetHeight);
                const ctx = cv.getContext("2d");
                let all_chars = [];
                const dots = [];
                const w = 25;
                const rows = (height / 25) >> 0;
                this.setLIU(ctx, width, dots, all_chars);
                this.update(ctx, width, height, dots, w, rows, all_chars);
            },
            setLIU(ctx, width, dots, all_chars) {
                ctx.font = "20px Arial";
                ctx.textAlign = "center";
                let arr = ['K', "I", "M", 'O'];
                const cols = (width / 25) >> 0;
                for (let i = 0; i < 4; i++) {
                    all_chars.push(arr[i]);
                }
                for (let i = 0; i < cols; i++) {
                    let chars = [];
                    dots.push({
                        y: ((Math.random() * 20) >> 0) * -1,
                        x: i,
                        chars
                    });
                    for (let j = 0; j < 10; j++) {
                        chars.push(all_chars[(Math.random() * all_chars.length) >> 0]);
                    }
                }
            },
            update(ctx, width, height, dots, w, rows, all_chars) {
                ctx.clearRect(0, 0, width, height);
                ctx.save();
                ctx.fillStyle = `rgba(30, 158, 32, 0.5)`;
                for (let item of dots) {
                    let len = item.chars.length;
                    for (let i = 0; i < len - 1; i++) {
                        ctx.fillStyle = `rgba(30, 158, 32, ${(i + 1) / (len + 1)})`;
                        ctx.fillText(item.chars[i], w * item.x, w * (item.y + i));
                    }
                    ctx.fillStyle = "rgb(255,255,255)";
                    ctx.fillText(item.chars[len - 1], w * item.x, w * (item.y + len - 1));
                    item.chars.splice(0, 1);
                    item.chars.push(all_chars[(Math.random() * all_chars.length) >> 0]);
                    if (item.y > rows) {
                        item.y = ((Math.random() * 20) >> 0) * -1;
                    } else {
                        item.y++;
                    }
                }
                ctx.restore();
                let _ = this;
                this.Timer = setTimeout(function () {
                    _.update(ctx, width, height, dots, w, rows, all_chars);
                }, 80);
            },
        },
        mounted() {
            this.setDATA();  //设置背景流水图
            window.onresize = () => {
                return (() => {
                    if (document.querySelector("#login")) {
                        clearTimeout(this.Timer);
                        this.setDATA(); //监听窗口变化
                    }
                })()
            }
        },
        beforeDestroy() {
            clearTimeout(this.Timer);
        },
        created() {
            this.getCode(); //重新获取验证码
            // 注册回车事件
            var _self = this;
            document.onkeydown = function (e) {
                let keys = 0;
                if (window.event == undefined) {
                    keys = e.keyCode;
                } else {
                    keys = window.event.keyCode;
                }
                if (keys == 13) {
                    _self.codeLogin('loginForms');
                }
            }
            //清除token
            if (this.$common.getCookie('tibiot-personal-card')) {
                document.cookie = 'tibiot-personal-card=' + this.$common.getCookie('tibiot-personal-card') + ';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';
                window.localStorage.removeItem("vuex-along");//清除vue-along
            }
        }
    };
</script>
<style scoped>
    #login {
        overflow: hidden;
        width: 100%;
        height: 100%;
        background: #F9F9FB;
    }

    .Left_top {
        height: 78px;
        line-height: 78px;
        font-size: 18px;
        color: #8E96A2;
    }

    .loginRight {
        width: 480px;
        height: 320px;
        margin: 0px auto;
    }

    .loginStyle {
        position: absolute;
        top: 20%;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(239, 239, 239, .6);
        border:1px solid #ddd;
    }

    .authcode {
        width: 400px;
        height: 32px;
        line-height: 32px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-bottom: 5px;
    }
</style>
<style>
    .iptStyle .el-input--small .el-input__inner {
        height: 38px !important;
        line-height: 38px !important;
        text-indent: 4px;
    }

    .iptStyle .el-button--small, .el-button--small.is-round {
        display: inline-block;
        width: 329px;
        padding: 10px 0px !important;
    }

    .rememberPas .el-checkbox__label {
        font-size: 12px;
    }

    #login td, #login th {
        border: none !important;
    }

    .loginRight .el-tabs__header {
        margin: 0 0 7px;
    }
</style>



// WEBPACK FOOTER //
// src/views/pc/login.vue